import {Injectable} from '@angular/core';

import {GtmInitialize} from '../../models/gtm-initialize.model';

declare global {
    interface Window {
        dataLayer: any[];
        title: string;
    }
}

@Injectable({
    providedIn: 'root'
})
export class GoogleTagManagerService {
    constructor() {}

    setUpDataLayer(gtmInitialize: GtmInitialize): void {
        window.dataLayer.push(JSON.parse(JSON.stringify(gtmInitialize)));
    }
}
